import type { CalibrationJSONObject } from '@ikegps/core-api';
import { IkeRestObject } from './base';

export class IkeObjectCalibration extends IkeRestObject<CalibrationJSONObject> {
	className = 'Calibration' as const;
	actionName = 'calibration';
	object: CalibrationJSONObject;
}
